<template>
  <div class="admin-share-stats">
    <div class="page-header">
      <h2>分享活动统计</h2>
    </div>

    <!-- 统计卡片 -->
    <div class="stats-cards">
      <div class="stat-card pending">
        <div class="stat-value">{{ stats.pendingCount || 0 }}</div>
        <div class="stat-label">待审核</div>
      </div>
      <div class="stat-card approved">
        <div class="stat-value">{{ stats.approvedCount || 0 }}</div>
        <div class="stat-label">已通过</div>
      </div>
      <div class="stat-card distributed">
        <div class="stat-value">{{ stats.distributedCount || 0 }}</div>
        <div class="stat-label">已发放</div>
      </div>
      <div class="stat-card rejected">
        <div class="stat-value">{{ stats.rejectedCount || 0 }}</div>
        <div class="stat-label">已拒绝</div>
      </div>
      <div class="stat-card total">
        <div class="stat-value">¥{{ stats.totalRewardValue || 0 }}</div>
        <div class="stat-label">奖励总额</div>
      </div>
    </div>

    <!-- 活动列表 -->
    <el-card class="campaigns-card" v-loading="campaignsLoading">
      <div slot="header" class="card-header">
        <span>活动列表</span>
      </div>
      <el-table :data="campaigns" stripe>
        <el-table-column prop="name" label="活动名称" min-width="150" />
        <el-table-column prop="rewardType" label="奖励类型" width="100">
          <template slot-scope="{row}">{{ rewardTypeText(row.rewardType) }}</template>
        </el-table-column>
        <el-table-column prop="rewardValue" label="奖励金额" width="100">
          <template slot-scope="{row}">¥{{ row.rewardValue }}</template>
        </el-table-column>
        <el-table-column prop="status" label="状态" width="100">
          <template slot-scope="{row}">
            <el-tag :type="row.status === 'ACTIVE' ? 'success' : 'info'">
              {{ row.status === 'ACTIVE' ? '上架' : '下架' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="startDate" label="开始日期" width="120" />
        <el-table-column prop="endDate" label="结束日期" width="120" />
      </el-table>
    </el-card>

    <!-- 最近奖励记录 -->
    <el-card class="recent-rewards-card" v-loading="rewardsLoading">
      <div slot="header" class="card-header">
        <span>最近奖励记录</span>
        <el-button size="mini" @click="$router.push('/admin/share-rewards')">查看全部</el-button>
      </div>
      <el-table :data="recentRewards" stripe>
        <el-table-column prop="id" label="ID" width="60" />
        <el-table-column prop="registrantUsername" label="注册用户" width="120" />
        <el-table-column prop="rewardValue" label="奖励金额" width="100">
          <template slot-scope="{row}">¥{{ row.rewardValue }}</template>
        </el-table-column>
        <el-table-column prop="rewardStatus" label="状态" width="100">
          <template slot-scope="{row}">
            <el-tag :type="statusTag(row.rewardStatus)" size="mini">{{ statusText(row.rewardStatus) }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="distributionMethod" label="发放方式" width="100">
          <template slot-scope="{row}">{{ distributionText(row.distributionMethod) }}</template>
        </el-table-column>
        <el-table-column prop="distributionStatus" label="发放状态" width="100">
          <template slot-scope="{row}">
            <el-tag :type="row.distributionStatus === 'DELIVERED' ? 'success' : 'warning'" size="mini">
              {{ row.distributionStatus === 'DELIVERED' ? '已发放' : '待发放' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="createdAt" label="创建时间" width="160" />
      </el-table>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'AdminShareStats',
  data() {
    return {
      stats: {},
      campaigns: [],
      recentRewards: [],
      campaignsLoading: false,
      rewardsLoading: false
    };
  },
  created() {
    this.loadStats();
    this.loadCampaigns();
    this.loadRecentRewards();
  },
  methods: {
    async loadStats() {
      try {
        const response = await this.$api.get('/admin/share/stats');
        this.stats = response.data || response || {};
      } catch (error) {
        console.error('加载统计失败:', error);
      }
    },

    async loadCampaigns() {
      this.campaignsLoading = true;
      try {
        const response = await this.$api.get('/admin/share/campaigns');
        this.campaigns = response.data || response || [];
      } catch (error) {
        console.error('加载活动列表失败:', error);
      } finally {
        this.campaignsLoading = false;
      }
    },

    async loadRecentRewards() {
      this.rewardsLoading = true;
      try {
        const response = await this.$api.get('/admin/share/rewards', {
          params: { page: 0, size: 10 }
        });
        const data = response.data || response;
        this.recentRewards = data.content || data.items || [];
      } catch (error) {
        console.error('加载奖励记录失败:', error);
      } finally {
        this.rewardsLoading = false;
      }
    },

    rewardTypeText(type) {
      const map = { CASH: '现金', COUPON: '优惠券', PRODUCT: '商品' };
      return map[type] || type;
    },

    statusTag(status) {
      const map = { PENDING: 'warning', APPROVED: 'success', REJECTED: 'danger', DISTRIBUTED: 'info' };
      return map[status] || '';
    },

    statusText(status) {
      const map = { PENDING: '待审核', APPROVED: '已通过', REJECTED: '已拒绝', DISTRIBUTED: '已发放' };
      return map[status] || status;
    },

    distributionText(method) {
      const map = { DELIVERY: '配送', PICKUP: '自提', COUPON_CODE: '优惠券码' };
      return map[method] || method || '-';
    }
  }
};
</script>

<style scoped>
.admin-share-stats {
  padding: 20px;
}

.page-header {
  margin-bottom: 20px;
}

.page-header h2 {
  margin: 0;
  font-size: 20px;
}

.stats-cards {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 16px;
  margin-bottom: 24px;
}

.stat-card {
  background: white;
  border-radius: 10px;
  padding: 20px;
  text-align: center;
  box-shadow: 0 2px 8px rgba(0,0,0,0.05);
}

.stat-value {
  font-size: 28px;
  font-weight: bold;
  color: #333;
}

.stat-label {
  font-size: 14px;
  color: #666;
  margin-top: 8px;
}

.stat-card.pending .stat-value { color: #e6a23c; }
.stat-card.approved .stat-value { color: #67c23a; }
.stat-card.distributed .stat-value { color: #409eff; }
.stat-card.rejected .stat-value { color: #f56c6c; }
.stat-card.total .stat-value { color: #e74c3c; }

.campaigns-card,
.recent-rewards-card {
  margin-bottom: 20px;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

@media (max-width: 768px) {
  .admin-share-stats {
    padding: 12px;
  }

  .page-header h2 {
    font-size: 18px;
  }

  .stats-cards {
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;
  }

  .stat-card {
    padding: 14px;
  }

  .stat-value {
    font-size: 22px;
  }

  .stat-label {
    font-size: 12px;
  }

  .campaigns-card,
  .recent-rewards-card {
    margin-bottom: 12px;
  }

  /* 表格横向滚动 */
  .el-table {
    font-size: 12px;
  }

  .el-table__header th,
  .el-table__body td {
    padding: 6px 4px;
    font-size: 11px;
  }

  .card-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
}
</style>
